import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from '../dialog.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-leaveaprovechangestatus',
  templateUrl: './leaveaprovechangestatus.component.html',
  styleUrls: ['./leaveaprovechangestatus.component.scss']
})
export class LeaveaprovechangestatusComponent implements OnInit {

  savingFlag: boolean = false;
  form: any = {};
  approvedMessage: any;
  employee_id: any;

  pageType: any;
  message: string;
  messageType: string;
  private isLeaveApproveCalled: boolean = false; // Ensure leaveApprove is called once

  constructor(
    public rout: Router,
    public toast: ToastrManager,
    public alert: DialogComponent,
    public dialog: DialogComponent,
    public service: DatabaseService,
    public route: ActivatedRoute,
    private router: Router
  ) {
    this.form.status = 'Approve';
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log('Route params:', params);
      this.employee_id = params.id;
      this.form.leaveId = params.id;
      this.leaveApprove();
    });

    // Subscribe to router events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      console.log('NavigationEnd event:', event);
    });
  }

  leaveApprove() {
    if (this.savingFlag) return; // Prevent multiple calls
    this.savingFlag = true;
    console.log('Calling leaveApprove with form:', this.form);

    this.service.post_rqst({ 'data': this.form }, "CronJob/approvalStatusChange").subscribe(
      result => {
        console.log('API response:', result);
        this.savingFlag = false;
        if (result['statusCode'] === 200) {
          this.message = '"Approved", "Successfully"';
          this.messageType = 'success';
          this.rout.navigate(['/thanks/' + this.employee_id]);
        } else {
          this.message = result['statusMsg'];
          this.messageType = 'error';
        }
      },
      err => {
        console.error('API error:', err);
        this.savingFlag = false;
        this.message = 'An error occurred. Please try again.';
        this.messageType = 'error';
      }
    );
  }
}
